import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default from 'react';
import { ProgressBar } from 'react-aria-components';
import Spinner from '../spinner/spinner.esm.js';
import Slot from '../layout/slot/slot.esm.js';

var _excluded = ["isPending"];
function getPendingButtonLayout(params) {
  var color = params.color,
    children = params.children,
    _params$loadingText = params.loadingText,
    loadingText = _params$loadingText === void 0 ? 'Loading...' : _params$loadingText,
    orientation = params.orientation;
  return function PendingButtonLayout(_ref) {
    var isPending = _ref.isPending,
      props = _objectWithoutProperties(_ref, _excluded);
    return isPending ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ProgressBar, {
      className: "absolute inset-0",
      "aria-label": loadingText,
      isIndeterminate: true
    }, /*#__PURE__*/React__default.createElement(Slot, {
      justify: "center",
      alignItems: "center",
      fullHeight: true
    }, /*#__PURE__*/React__default.createElement(Spinner, {
      color: "on-".concat(color)
    }))), /*#__PURE__*/React__default.createElement(Slot, {
      className: isPending ? 'opacity-0' : '',
      direction: orientation,
      alignItems: "center",
      gap: "sm"
    }, typeof children === 'function' ? children(_objectSpread2(_objectSpread2({}, props), {}, {
      isPending: isPending,
      defaultChildren: null
    })) : children)) : typeof children === 'function' ? children(_objectSpread2(_objectSpread2({}, props), {}, {
      isPending: isPending,
      defaultChildren: null
    })) : children;
  };
}

export { getPendingButtonLayout as default };
//# sourceMappingURL=pending-button-layout.esm.js.map
